import { render } from "./DraggableSolventsTable.vue?vue&type=template&id=68d098e6"
import script from "./DraggableSolventsTable.vue?vue&type=script&lang=js"
export * from "./DraggableSolventsTable.vue?vue&type=script&lang=js"

import "./DraggableSolventsTable.vue?vue&type=style&index=0&id=68d098e6&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__